import { AspectRatio, Group, Loader,Text, createStyles } from '@mantine/core';
import { useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import { useSelector } from "react-redux";

const useStyles = createStyles((theme) => ({
  headerbg: {
    backgroundColor: "#ffffff",	
  },
  loaderback: {	
    vheight: `80vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "80vh",
    minWidth: "50vw",
    position: "relative",
  },



  
}));

/**
 * Renders am iframe for a document to be signed.
 *
 * @param {Object} props - The component props.
 * @param {string} props.resourceId - The ID of the resource to display.
 * @return {JSX.Element} The JSX element representing the signed document.
 */
const NotarSetupSignsInDoc = (props:any ) => {
    const { classes } = useStyles();
    const showdocs = useSelector((state: any) => state.user.meetingdocs)

   
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  

    useEffect(() => {
      const handleResize = () => {
       
        setScreenHeight(window.innerHeight);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    

    let doclink = showdocs.filter((obj: { resourceId: any }) => {
        return obj.resourceId === props.resourceId
      });
    
      let docurl
    if (doclink && doclink.length > 0 && doclink[0].sigSettingsIFrameUrl) {
        docurl = doclink[0].sigSettingsIFrameUrl;
      } else {
        return (null)
      }

   

   
    if (props.usertosignsent){ 
    return (
      <>
        <AspectRatio ratio={16 / 8} sx={{ maxWidth: 1920, maxHeight: screenHeight - 250 }} mx="auto">
          <iframe
              src={docurl}
              title={"Testraum"}
              allow="camera;microphone;display-capture"
              allowFullScreen
              frameBorder= "0"
            />
        </AspectRatio>
        
      </>
    )
  } else {
    return (
      <div className={classes.loaderback}>
                       <Group>
                        <Loader color="green" size="xl" />
                        <Text>{intl.get('LOADER_PREPARE_SIGBLOCK')} </Text>
                        </Group>
                    </div>
      )
  }
};

export default NotarSetupSignsInDoc;